import Vue from 'vue'
import Toast from './Toast.vue'

export default {
  install(Vue, defaultOptions = {}) {
    const CONSTRUCTOR = Vue.extend(Toast)
    let toast = new CONSTRUCTOR()
    let vm = toast.$mount()
    document.querySelector('body').appendChild(vm.$el)
    Vue.toast = Vue.prototype.$toast = toast
  }
}


// WEBPACK FOOTER //
// ./src/plugins/toast/index.js